export enum IngredientType {
  /** Solid ingredients: vegetables, meat, pasta, rice, dairy, etc. */
  Solid = 'solid',
  /** Liquid ingredients: water, milk, oil, broth, wine, etc. */
  Liquid = 'liquid',
  /** Spices and seasonings: salt, pepper, paprika, oregano, etc. */
  Spice = 'spice',
}
